import React, { useRef } from 'react';
import { VirtualizedListProps } from './virtualized-list-props';
import { cx } from '@mint/core';
import styled from 'styled-components';
import { useVirtualizedList } from './use-virtualized-list';

/**
 * List root class name.
 */
const ROOT_CLASS_NAME = 'virtualized-list';

/**
 * Component to use.
 */
const DEFAULT_COMPONENT = 'div';

/**
 * List component implementation before styling.
 */
export const VirtualizedListComponent = React.forwardRef<
  any,
  VirtualizedListProps
>(
  (props: VirtualizedListProps, ref): React.ReactElement => {
    const {
      batchSize,
      children,
      className,
      component: Component = DEFAULT_COMPONENT,
      onScroll,
      initialBatchSize,
      overscan,
      style,
      theme: _,
      threshold,
      ...rest
    } = props;

    const scrollable = ref || useRef(null);

    const elements = React.Children.toArray(children) as React.ReactElement[];

    const bindVirtualizedList = useVirtualizedList(elements, {
      batchSize,
      initialBatchSize,
      onScroll,
      overscan,
      ref: scrollable as any,
      threshold,
    });

    const componentProps = {
      ...rest,
      className: cx(ROOT_CLASS_NAME, className),
      ...bindVirtualizedList,
      style: { ...style, ...bindVirtualizedList.style },
    };

    return <Component {...componentProps} />;
  },
);

VirtualizedListComponent.displayName = 'VirtualizedList';

export const VirtualizedList = styled(VirtualizedListComponent)``;
